export default __webpack_public_path__ + "static/media/FMSstamp-02.a562fa27.png";